import {Controller} from "@hotwired/stimulus";
import {config} from "../sneat/config";
import ApexCharts from "apexcharts-clevision";

export default class extends Controller {
  static values = {
    data: Array
  }

  connect() {

    let options = {
      chart: {
        height: 80,
        // width: 175,
        type: 'line',
        toolbar: {
          show: false
        },
        dropShadow: {
          enabled: true,
          top: 10,
          left: 5,
          blur: 3,
          color: config.colors.warning,
          opacity: 0.15
        },
        sparkline: {
          enabled: true
        }
      },
      grid: {
        show: false,
        padding: {
          right: 8
        }
      },
      colors: [config.colors.warning],
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: 5,
        curve: 'smooth'
      },
      series: [
        {
          name: 'Conclusão',
          data: this.dataValue,
        }
      ],
      xaxis: {
        show: false,
        lines: {
          show: false
        },
        labels: {
          show: false
        },
        axisBorder: {
          show: false
        }
      },
      yaxis: {
        show: false
      }
    }
    let chart = new ApexCharts(document.querySelector("#goalSprintChart"), options);
    chart.render();
  }
}
